var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import UserAvatar from '@web/components/UserAvatar';
export var AvatarGroup = function (_a) {
    var users = _a.users;
    return (_jsx("div", __assign({ className: "flex -space-x-2 overflow-hidden" }, { children: users.map(function (user) { return (_jsx(UserAvatar, { user: user, size: 'small' })); }) })));
};
